const BIRTHDAY_IMAGES = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/h61p32vo_FOTO%2022.webp",
    alt: "Aniversário Jardim da Helena - tema flores rosa",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/h6xvpffl_FOTO%2023.jpg.webp",
    alt: "Aniversário tema Nárnia - verde e dourado",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/0b160euv_FOTO%2025.png",
    alt: "Aniversário Maria Sofia - tema Chapeuzinho Vermelho",
  },
];

export default function Birthdays() {
  return (
    <section data-testid="birthdays-section" className="py-24 bg-[#E4DCCC]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#E4077B] text-xs tracking-[0.25em] uppercase font-medium">Sonhos Realizados</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Aniversários Temáticos
          </h2>
          <div className="w-12 h-0.5 bg-[#E4077B] mx-auto mt-4" />
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-[#555555] leading-relaxed text-base">
            Cada aniversário marca um novo capítulo cheio de alegria. Criamos decorações personalizadas para meninos e meninas, transformando temas, cores e ideias em cenários únicos, criados para tornar esse dia ainda mais especial e inesquecível.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {BIRTHDAY_IMAGES.map((img, i) => (
            <div
              key={i}
              className="overflow-hidden rounded-3xl hover-lift"
              data-testid={`birthday-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-72 md:h-96 object-cover transition-transform duration-500 hover:scale-105"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
